<template>
  <SignupFieldComponent
    :field
    :value="modelValue"
    :rules
    v-slot="{ id, invalid, touch }"
  >
    <TextInput
      :id
      :type
      :modelValue
      :invalid
      @update:modelValue="$emit('update:modelValue', $event)"
      @blur="touch"
    />
  </SignupFieldComponent>
</template>

<script setup lang="ts">
import type { ValidationRuleCollection } from "@vuelidate/core";
import type { GeneratorReviewKey } from "./fieldKeys";
import SignupFieldComponent from "./SignupFieldComponent.vue";
import TextInput from "./TextInput.vue";

withDefaults(
  defineProps<{
    modelValue?: string | null;
    field: GeneratorReviewKey;
    rules?: ValidationRuleCollection;
    type?: "text" | "date";
  }>(),
  { modelValue: null, rules: () => ({}), type: "text" }
);

defineEmits<{
  "update:modelValue": [value: string];
}>();
</script>
